
// PriceIncomeChart.jsx
import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

const PriceIncomeChart = ({ ticker = "", dataGraph = [] }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      sx={{ mt: 4 }}
    >
      <Card
        sx={{
          width: "95%",
          maxWidth: 900,
          background: "#1c1c1c", // dark grey
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
          padding: "8px",
        }}
      >
        <CardContent>
          <Typography
            variant="h6"
            sx={{ color: "#fff", mb: 2, textAlign: "center" }}
          >
            {ticker} — Price &amp; Net Income (Time Series)
          </Typography>

          <Box sx={{ height: 500, width: "100%" }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={dataGraph}>
                <XAxis dataKey="year" stroke="#fff" />

                <YAxis
                  yAxisId="left"
                  stroke="#fff"
                  tickFormatter={(value) => `$${(value / 1_000_000).toFixed(0)}M`}
                />

                <YAxis
                  yAxisId="right"
                  orientation="right"
                  stroke="#1e90ff"
                  tickFormatter={(value) => `$${value.toFixed(0)}`}
                />

                <Tooltip
                  contentStyle={{
                    backgroundColor: "#2c2c2c",
                    color: "#fff",
                    borderRadius: "8px",
                    border: "none",
                  }}
                  formatter={(value, name) => {
                    if (name === "netIncome") {
                      return [`$${(value / 1_000_000).toFixed(2)}M`, "Net Income"];
                    }
                    if (name === "price") {
                      return [`$${Number(value).toFixed(2)}`, "Price"];
                    }
                    return value;
                  }}
                  labelFormatter={(label) => `Year: ${label}`}
                />

                <Line
                  yAxisId="left"
                  type="natural"
                  dataKey="netIncome"
                  stroke="lightgreen"
                  strokeWidth={3}
                  dot={{ r: 2 }}
                />

                <Line
                  yAxisId="right"
                  type="natural"
                  dataKey="price"
                  stroke="#1e90ff"
                  strokeWidth={3}
                  dot={{ r: 2 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PriceIncomeChart;
